export const isValidData = (data) => {
  const validation = data.map(item => !!item);
  return !validation.includes(false);
}

export const isValidEmail = (email) => {
  return /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(email);
}